module.exports = __webpack_public_path__ + "static/media/Andrina 4.b19eddf2.png";